var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousingExpenseRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.7H5C4.44772 21.7 4 21.2523 4 20.7V11.7H1L11.3273 2.3115C11.7087 1.96475 12.2913 1.96475 12.6727 2.3115L23 11.7H20V20.7C20 21.2523 19.5523 21.7 19 21.7ZM6 19.7H18V9.85745L12 4.4029L6 9.85745V19.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 14.6667H13.7778C14.0232 14.6667 14.2222 14.4802 14.2222 14.25C14.2222 14.0199 14.0232 13.8334 13.7778 13.8334H10.2222C8.99492 13.8334 8 12.9007 8 11.75C8 10.5995 8.99492 9.66672 10.2222 9.66672H11.1111V8.00005H12.8889V9.66672H15.1111V11.3334H10.2222C9.97676 11.3334 9.77777 11.5199 9.77777 11.75C9.77777 11.9802 9.97676 12.1667 10.2222 12.1667H13.7778C15.0051 12.1667 16 13.0994 16 14.25C16 15.4007 15.0051 16.3334 13.7778 16.3334H12.8889V18H11.1111V16.3334H8.88889V14.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousingExpenseRequest);
export default __webpack_public_path__ + "static/media/housing-expense-request.c15a87c64707fca05740b4899f0f8880.svg";
export { ForwardRef as ReactComponent };